export default __webpack_public_path__ + "static/media/01.cee83d64.png";